var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "swap_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m315.85,63.9c-2.39-2.38-5.56-3.69-8.93-3.69s-6.54,1.32-8.92,3.71c-4.92,4.93-4.91,12.93.02,17.85l34.19,34.12-185.08.19c-6.96,0-12.61,5.67-12.61,12.63s5.67,12.61,12.63,12.61l185.03-.19-34.42,34.49c-2.38,2.39-3.69,5.56-3.69,8.93s1.32,6.54,3.7,8.92c2.39,2.38,5.56,3.69,8.93,3.69s6.54-1.32,8.92-3.71l55.96-56.08c2.38-2.39,3.69-5.56,3.69-8.93s-1.32-6.54-3.71-8.92l-55.73-55.61Z",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.01,236.56c2.38-2.39,5.55-3.7,8.92-3.71s6.54,1.31,8.93,3.69c4.93,4.91,4.93,12.92.02,17.85l-34.12,34.19,185.08-.19c6.96,0,12.63,5.65,12.63,12.61s-5.65,12.63-12.61,12.63l-185.03.19,34.49,34.42c2.39,2.38,3.7,5.55,3.71,8.92s-1.31,6.54-3.69,8.93c-2.38,2.39-5.55,3.7-8.92,3.71-3.37,0-6.54-1.31-8.93-3.69l-56.08-55.96c-2.39-2.38-3.7-5.55-3.71-8.92s1.31-6.54,3.69-8.93l55.62-55.73Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.2e7659f212fb25820189c04a765e0ca6.svg";
export { ForwardRef as ReactComponent };